require('../../modules/es6.math.clz32');
module.exports = require('../../modules/_core').Math.clz32;



//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/fn/math/clz32.js
// module id = 1054
// module chunks = 61